module.exports = __webpack_public_path__ + "img/jslc5.ba5d7c07.png";